export const getSegmentKey = (host = ''): string => {
  try {
    if (host?.includes('localhost')) {
      return 'NazJECklTzKBLmNIxOW56Co5llBHTkpY';
    }
    if (
      process.env.NEXT_PUBLIC_ENVIRONMENT === 'dev' ||
      process.env.NEXT_PUBLIC_ENVIRONMENT === 'master'
    ) {
      return 'NazJECklTzKBLmNIxOW56Co5llBHTkpY';
    }
    return 'HAFmvakfiDMcgb9woKsT6C6hvubtp2yT';
  } catch {
    return 'NazJECklTzKBLmNIxOW56Co5llBHTkpY';
  }
};
